/**
 * @author Stefano Zina
 */
import { getDefaultSearchBean } from "./RealEstateSearchBean";
export function getDefaultSaveSearchBean() {
  return {
    active: true,
    hourly: false,
    latitude: 0,
    longitude: 0,
    saveSearchParameterId: null,
    searchBean: getDefaultSearchBean(),
    title: ""
  };
}
export function getDefaultSaveSearchOptions() {
  return {
    active: false,
    hourly: false,
    title: "",
    modified: false
  };
}